const MS_PER_WEEK = 7 * 24 * 60 * 60 * 1000;

/**
 * Which program week a date falls in, counting from the client's `serviceStartAt`.
 *
 * Returns `undefined` for a client with no start date **and for a date before it**, so a
 * not-yet-started client can never be labelled "week 0". Only check-in photos carry a week — a chat
 * quote has no meaningful program week — so the caller decides when to ask.
 *
 * Resolved here rather than left to the app: the week has to be shown on the crop step, so the
 * dashboard needs the number anyway, and storing it means the card never has to reach for the
 * client's record to render.
 *
 * @param {Date} [serviceStartAt] from the client's user document
 * @param {Date} [at] when the photo was taken
 * @returns {number|undefined}
 */
const resolveWeekNumber = (serviceStartAt, at) => {
  if (!serviceStartAt || !at) {
    return undefined;
  }

  const elapsed = at.getTime() - serviceStartAt.getTime();
  if (Number.isNaN(elapsed) || elapsed < 0) {
    return undefined;
  }

  return Math.floor(elapsed / MS_PER_WEEK) + 1;
};

export { resolveWeekNumber };
